<template>
    <div class="yq-penalty-list" v-if="config&&data">
        <div class="yq-penalty-summary" v-for="row in data" :key="row.id">
            <div class="yq-penalty-summary-head">
                <div class="yq-penalty-summary-title" @click="showDetails(row.id)">{{getTitle(row)}}</div>
                <div class="yq-penalty-summary-date">
                </div>
            </div>
            <div class="yq-penalty-summary-row">
                <div class="yq-penalty-summary-col-label">处罚公司：</div>
                <div class="yq-penalty-summary-col-value"
                     :style="join(row.source[config.targetCompany.config.field])?{color:'#FF5E14'}:{}">
                    {{join(row.source[config.targetCompany.config.field])||'无'}}
                </div>
                <div class="yq-penalty-summary-col-label">处罚人：</div>
                <div class="yq-penalty-summary-col-value"
                     :style="join(row.source[config.targetPerson.config.field])?{color:'#FF5E14'}:{}">
                    {{join(row.source[config.targetPerson.config.field])||'无'}}
                </div>
                <div class="yq-penalty-summary-col-label">相关公司：</div>
                <div class="yq-penalty-summary-col-value"
                     :style="join(row.source[config.relatedCompany.config.field])?{color:'#FF5E14'}:{}">
                    {{join(row.source[config.relatedCompany.config.field])||'无'}}
                </div>
                <div class="yq-penalty-summary-col-label">文号：</div>
                <div class="yq-penalty-summary-col-value">{{config.docNo?join(row.source[config.docNo.config.field]):''}}</div>
            </div>
            <div class="yq-penalty-summary-row">
                <div class="yq-penalty-summary-col-label">处罚机构：</div>
                <div class="yq-penalty-summary-col-value">{{row.source[config.organization.config.field]}}</div>
                <div class="yq-penalty-summary-col-label">处罚类型：</div>
                <div class="yq-penalty-summary-col-value">{{join(row.source[config.type.config.field])}}</div>
                <div class="yq-penalty-summary-col-label">来源站点：</div>
                <div class="yq-penalty-summary-col-value">{{row.source[config.docSite.config.field]}}</div>
                <div class="yq-penalty-summary-col-label"></div>
                <div class="yq-penalty-summary-col-value">
                    <pretty-date-time :value="row.source[config.date.config.field]" format="uuuu-MM-dd"
                                      :value-format="dateField.dateValueFormat" java-format></pretty-date-time>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import preview from '../../assets/images/templates/penalty_list.png'
    import thumbnail from '../../assets/images/templates/penalty_list_thumbnail.png'
    import templateUtils from '../../service/view-template-utils'

    const regions = {
        title: {
            name: '标题',
            config: {
                field: {
                    name: '标题字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        date: {
            name: '日期',
            config: {
                field: {
                    name: '日期字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        targetCompany: {
            name: '处罚公司',
            config: {
                field: {
                    name: '处罚公司字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        targetPerson: {
            name: '处罚人员',
            config: {
                field: {
                    name: '处罚人员字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        relatedCompany: {
            name: '相关公司',
            config: {
                field: {
                    name: '相关公司字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        organization: {
            name: '处罚机构',
            config: {
                field: {
                    name: '处罚机构字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        type: {
            name: '处罚类型',
            config: {
                field: {
                    name: '处罚类型字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docSite: {
            name: '来源站点',
            config: {
                field: {
                    name: '来源站点字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        docNo: {
            name: '文号',
            config: {
                field: {
                    name: '文号字段',
                    required: true,
                    type: 'field'
                }
            }
        },
    }
    export default {
        name: "PenaltyList",
        props: {
            config: Object,
            data: Array,
            datasource: Object,
            pageNumber: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 10
            }
        },
        computed: {
            dateField () {
                return this.datasource.fields.find(field => field.name === this.config.date.config.field)
            }
        },
        methods: {
            showDetails(id) {
                this.$emit('show-details', id)
            },
            join(value){
                if(!value){
                    return ''
                }else if(Array.isArray(value)){
                    return value.join('、')
                }else {
                    return value+''
                }
            },
            getTitle(row){
                return row.source[this.config.title.config.field] || (row.source[this.config.organization.config.field] + '（行政处罚信息）')
            }
        }
    }
    function getFields(config){
        const fields = []
        for(const regionKey in config){
            if(config[regionKey]){
                fields.push(config[regionKey].config.field)
            }
        }
        return fields
    }
    function validateConfig(config){
        return templateUtils.validateConfig(regions, config)
    }
    export {regions, preview, thumbnail, getFields, validateConfig}
</script>

<style scoped>

</style>
